import CategoryItem from './category-item';

export default CategoryItem;
